// extracted by mini-css-extract-plugin
module.exports = {"content":"Trending_content__1ZMja"};